import { getSortedCards } from "../helpers";
export default function (store, ev) {
    if (!ev) {
        store.setState({ sort: null });
        return;
    }
    const state = store.getState();
    const columnId = ev.columnId;
    const by = ev.by || "label";
    const dir = ev.dir || "asc";
    const preserve = ev.preserve || false;
    let sort = state.sort || {};
    if (columnId) {
        if ("column" in sort === false) {
            sort = {
                columns: {},
            };
        }
        sort.columns[columnId] = { by, dir, preserve };
    }
    else {
        sort = {
            dir,
            by,
            preserve,
        };
    }
    const cards = getSortedCards({ ...state, sort }, store.sortRule);
    if (preserve) {
        store.setState({ sort, cards });
    }
    else {
        store.setState({ cards });
    }
}
//# sourceMappingURL=sort.js.map